<div class="quick-bet-action-button__taxation-liability" *ngIf="taxationLiability$ | async as taxationLiability">
    <bs-betslip-taxation-liability [taxBackGiven]="taxationLiability"></bs-betslip-taxation-liability>
</div>
